<h1>Cambiar Contraseña</h1>
<div class="mat-elevation-z4 divmarco">
  <form [formGroup]="resetearClaveForm" (ngSubmit)="onSubmit()">
    <h1>Datos para Nuevo Acceso</h1>
    <hr>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese contraseña actual" appearance="outline" class="input-width-275"
          floatLabel="always">
          <mat-label>Contraseña Actual:</mat-label>
          <input matInput formControlName="claveActual" name="claveActual" minlength="6" maxlength="15" autocomplete="off"
            required>
          <mat-icon matSuffix>lock_open</mat-icon>
          <mat-error *ngIf="resetearClaveForm.controls['claveActual'].hasError('required')">Contraseña Actual es
            requerida.
          </mat-error>
          <mat-error *ngIf="resetearClaveForm.controls['claveActual'].hasError('pattern')">Contraseña no cumple especificaciones.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese nueva contraseña" appearance="outline" class="input-width-275"
          floatLabel="always">
          <mat-label>Nueva Contraseña:</mat-label>
          <input matInput formControlName="nuevaClave" name="nuevaClave" minlength="6" maxlength="15" autocomplete="off" required>
          <mat-icon matSuffix>lock</mat-icon>
          <mat-error *ngIf="resetearClaveForm.controls['nuevaClave'].hasError('required')">Contraseña nueva es
            requerida.
          </mat-error>
          <mat-error *ngIf="resetearClaveForm.controls['nuevaClave'].hasError('pattern')">Contraseña no cumple especificaciones.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start start" class="divconten">
      <p style="font-weight: bold;" fxLayout="column">El campo contraseña debe cumplir con las siguientes
        especificaciones:</p>
      <p>-&nbsp;Al menos una letra en mayúscula.</p>
      <p>-&nbsp;Al menos una letra en minúscula.</p>
      <p>-&nbsp;Al menos un valor numérico.</p>
      <p>-&nbsp;Al menos un carácter especial: # ? ! &#64; $ % ^ & * .</p>
      <p>-&nbsp;Mínimo 6 caracteres.</p>
      <p>-&nbsp;Máximo 15 caracteres.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="divconten">
      <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
      class="divconten">
      <div fxLayout="column">
        <button mat-raised-button (click)="navigateMenu();" color="warn" type="button"
          class="align-center-middle">
          <span class="text-icon-space">Regresar a Home</span>
          <mat-icon>home</mat-icon>
        </button>
      </div>
      <div fxLayout="column">
        <button mat-raised-button color="primary" type="submit" class="align-center-middle">
          <span class="text-icon-space">Cambiar Contraseña</span>
          <mat-icon>lock_reset</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>